<template lang='pug'>
//- Image Zoom
div(:class='$style[`cc-popbox-imgZoom`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(:class='$style[`cc-content-new`]')
    div(:class='$style[`cc-content-photo`]')
      figure
        img(:src='src' width='100%' height='100%')

</template>

<script>
import { mapMutations } from 'vuex';

export default {
  props: {
    src: {
      type: String,
      default: '',
    },
  },

  // data() {
  //   return {
  //   }
  // },

  methods: {
    ...mapMutations({
      changePopZoomStatus: 'global/POPZOOM_STATUS',
    }),

    handleClosePopBox() {
      this.changePopZoomStatus({
        active: false,
        src: '',
      });
    },
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popImageZoom.scss';
</style>
